import { useTranslation } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { ChangePassword } from "routes/changePassword";
import useWindowWidth from "utills/InitWidthDevice";

const ChangePasswordWPS = () => {
  const windowWidth = useWindowWidth();
  const isMobile = Boolean(windowWidth && windowWidth < 1024);
  const { translate } = useTranslation();

  const breadcrumbItems = [
    {
      label: translate("my-profile"),
      href: "/profile",
    },
    {
      label: translate("change-password"),
      href: "",
    },
  ];

  return (
    <div className="w-full">
      <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />

      <div
        className={`${
          isMobile ? "p-[16px] pb-[110px]" : "p-[16px] pb-[100px]"
        } w-full pt-[32px]`}
      >
        <ChangePassword />
      </div>
    </div>
  );
};

export default ChangePasswordWPS;
